import alertify from 'alertifyjs/build/alertify.min.js';
import 'alertifyjs/build/css/alertify.min.css';
import './styles.scss';

alertify.defaults = {
  notifier: {
    position: 'top-right',
    closeButton: true,
  },
};

export default (msg) => {
  alertify.notify(msg, 'error', 10);
};
